import { atom, AtomEffect } from 'recoil';

const STORAGE_KEY = 'xuxu_password_auth';

// Persist authentication to localStorage so a refresh / revisit
// keeps the user logged in instead of re-showing the password modal.
const localStorageEffect: AtomEffect<boolean> = ({ setSelf, onSet }) => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'true') {
      setSelf(true);
    }
  } catch (e) {
    // localStorage unavailable (e.g. SSR / privacy mode) — ignore
  }

  onSet((newValue) => {
    try {
      if (newValue) {
        localStorage.setItem(STORAGE_KEY, 'true');
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
    } catch (e) {
      // ignore write errors
    }
  });
};

export const passwordAuthState = atom<boolean>({
  key: 'passwordAuthState',
  default: false,
  effects: [localStorageEffect],
});
